import * as React from 'react';
import { formValueSelector, InjectedFormProps, reduxForm } from 'redux-form';
import { IMtaActions, IMtaFormNames, IMtaState } from '../../../../../../../services/mta/models';
import { flow, get } from 'lodash';
import { connect } from 'react-redux';
import { IStore } from '../../../../../../../redux/IStore';
import { bindActionCreators } from 'redux';
import { mtaActions } from '../../../../../../../services/mta/actions';
import CancelHeader from '../components/CancelHeader';
import { Button, Form } from 'react-bootstrap';
import { FaSpinner } from 'react-icons/fa';
import { IAuthState } from '../../../../../../../services/auth/models';
import { push } from 'react-router-redux';
import { IQuoteActions, IQuoteState } from '../../../../../../../services/quote/models';
import { actions as quoteActions } from '../../../../../../../services/quote/reducer';
import PolicySummary from '../../PolicySummary';

interface IMTACancelConfirmProps extends InjectedFormProps<any> {
  mta: IMtaState;
  auth: IAuthState;
  quote: IQuoteState;
  isLoading: boolean;
  formValues: any;
  history: any;
  match: any;
  actions: {
    mta: IMtaActions;
    push: (route: string) => void;
    quote: IQuoteActions;
  };

}

class CancelConfirm extends React.Component<IMTACancelConfirmProps, any> {

  public handleSubmit = () => {
    const { actions, formValues, mta } = this.props;
    actions.mta.cancelPolicy(formValues, get(mta, 'selectedPolicy.id'));
  }

  public handleLapseRenewal = () => {
    const { actions, formValues, quote } = this.props;
    Promise.resolve(actions.quote.saveQuote(true, get(quote, 'application'))).then((renewalId) => {
      actions.mta.cancelRenewal(formValues, renewalId);
    });
  }

  private handleGoBack = () => {
    const { actions, mta, formValues } = this.props;
    const policyId = mta.selectedPolicy.id;
    const isSingleTrip = mta.selectedPolicy.metadata.scheme_type === 'single';
    const isRenewal = get(formValues, 'meta.cancel.renewal', false)
    // TODO: make this logic work with ST, AMT, RENEWAL

    if (isSingleTrip) {
      actions.push(`/account/make-a-change/single-trip-cancel-reason/${policyId}`);
    } else if (isRenewal) {
      actions.push(`/account/make-a-change/renewal-cancel-reason`);
    } else {
      actions.push(`/account/make-a-change/amt-cancel-reason/${policyId}`);
    }
  }

  private renderButtons = () => {
    const { submitting, submitFailed, valid, isLoading } = this.props;
    return (
      <>
        <Button
          type="button"
          bsStyle={'primary'}
          className="secondary-button medium-width"
          onClick={this.handleGoBack}
          disabled={submitting || (submitFailed && !valid || !valid || isLoading)}>
          DECLINE
        </Button>
        <Button
          type="submit"
          bsStyle={'primary'}
          className="secondary-button pull-right medium-width"
          disabled={submitting || (submitFailed && !valid || !valid || isLoading)}>
          {isLoading && (
            <FaSpinner className="fa-spin"/>
          )}
          CONFIRM
        </Button>
      </>
    )
  }

  render() {
    const { mta, handleSubmit, auth, formValues, quote } = this.props;
    const policyNumber = get(mta, 'selectedPolicy.policyNumber', null);
    const firstName = auth.customer?.firstName;
    const isRenewal = get(formValues, 'meta.cancel.renewal', false)
    const isSingleTrip = mta.selectedPolicy.metadata.scheme_type === 'single';
    const title = isRenewal ? `Cancel Renewal Quote ${get(quote, 'application.quoteReference')}` : `Cancel Policy ${policyNumber}`;

    return (

      <>
        <div className={'mt-30'}/>
        <CancelHeader
          title={title}
          showText={false}
          hideCustomerText={true}
          icon={'warning'}
        />

        <Form
          horizontal={true}
          onSubmit={handleSubmit(isRenewal ? this.handleLapseRenewal : this.handleSubmit)}
          autoComplete="off">
          <div>
            <>
              {isSingleTrip && (
                <div className={'cancel-confirm-body'}>
                  <p>{firstName}, your cover will end today, even if you are on a trip. This will leave you without
                    cover for emergency medical expenses.</p>
                  <p style={{ margin: '20px 0 20px 0' }}>
                    By continuing with the cancellation, you are confirming that you have not and are not intending to
                    make a claim on this policy.
                  </p>
                </div>
              )}

              {(isRenewal || !isSingleTrip) && (
                <div className={'cancel-confirm-body'}>
                  <p>{firstName}, remember to get travel insurance as soon as you book your next trip to protect
                    yourself against unexpected cancellations and delays.</p>
                  <p><b>1-in-4 of the claims we receive are because a trip has to be cancelled or delayed before it
                    starts due to unexpected events!*</b></p>
                  <p>
                    We would love you have you back as our customer, <b>so here’s a discount code for 10% off your next
                    Annual Multi-Trip policy with us – RETURN10.</b>
                  </p>
                  <p style={{ margin: '20px 0 20px 0' }}>
                    By continuing with the cancellation, you are confirming that you have not and are not intending to
                    make a claim on this policy.
                  </p>
                  <div style={{ textAlign: 'right', marginTop: '35px' }}>
                    <p style={{ fontStyle: 'italic', color: 'grey', fontSize: '12px' }}>* based on claims settled in 2023</p>
                  </div>
                </div>
              )}
            </>
          </div>


          <div className={'cancel-confirm-body'}>
            <div style={{ maxWidth: '600px', margin: 'auto' }}>
              <PolicySummary/>
            </div>
          </div>

          <div style={{ marginTop: '20px' }}>
            {this.renderButtons()}
          </div>

        </Form>
      </>

    )
  }
}

let selector;

export default flow([
  reduxForm({
    form: IMtaFormNames.CANCEL_FORM,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: false,
  }),
  (component) => {
    selector = formValueSelector(IMtaFormNames.CANCEL_FORM);
    return component;
  },
  connect(
    (state: IStore) => {
      const values = selector(state, 'data');
      return {
        auth: state.auth,
        mta: state.mta,
        quote: state.quote,
        isLoading: state.mta.isLoading,
        formValues: values,
      };
    },
    (dispatch) => ({
      actions: {
        mta: bindActionCreators({ ...mtaActions }, dispatch),
        push: bindActionCreators(push, dispatch),
        quote: bindActionCreators({ ...quoteActions }, dispatch),
      },
    }),
  ),
])(CancelConfirm);
